var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ul',{staticClass:"d-flex justify-content-between"},_vm._l((_vm.total),function(i){return _c('li',{key:i},[_c('a',{staticClass:"d-block rounded-top p-3 pointer",class:{active: _vm.currentIndex === (i - 1)},on:{"click":function($event){return _vm.setIndex(i - 1)}}},[_vm._v("\n            CZĘŚĆ "+_vm._s(i)+"\n        ")])])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }